import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Renders the official SLR logo image from settings.logo, with SVG fallback. */
export default function Logo({ size = 48, className = "", "data-testid": testid, settings: incoming }) {
  const [settings, setSettings] = useState(incoming || null);
  useEffect(() => {
    if (incoming) { setSettings(incoming); return; }
    (async () => {
      try { const { data } = await api.get("/settings"); setSettings(data || {}); } catch { /* ignore */ }
    })();
  }, [incoming]);

  const logoUrl = settings?.logo
    ? (settings.logo.startsWith("http") ? settings.logo : `${process.env.REACT_APP_BACKEND_URL}${settings.logo}`)
    : null;

  if (logoUrl) {
    return (
      <img src={logoUrl} alt="Spain Luxury Rentals" data-testid={testid}
        className={className}
        style={{ height: size, width: size, objectFit: "contain", display: "block" }} />
    );
  }

  // Fallback SVG
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" className={className} data-testid={testid} aria-label="Spain Luxury Rentals">
      <rect x="1" y="1" width="62" height="62" fill="#0C0C0C" stroke="#C9A55A" strokeWidth="1.5" rx="8" />
      <g fontFamily="Montserrat, sans-serif" fontWeight="900" fill="#F5F1EB">
        <text x="32" y="38" textAnchor="middle" fontSize="18" letterSpacing="3">SL<tspan fill="#C9A55A">R</tspan></text>
      </g>
    </svg>
  );
}
